'use client';

import * as React from 'react';
import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import { useTranslation } from 'react-i18next';
import Callout from '@/components/ui/Callout';
import type { IButtonProps } from '@/components/ui/Button';

type QueryErrorStateProps = {
  error?: unknown;
  buttons?: IButtonProps[];
};

const QueryErrorState: React.FC<QueryErrorStateProps> = ({ error, buttons = [] }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (error) {
      Sentry.captureException(error);
    }
  }, [error]);

  return (
    <Callout
      intent={'danger'}
      text={t('components.moduleError.description')}
      buttons={buttons}
    />
  );
};

export default QueryErrorState;
